import { EDIT_LISTING_SPACE,
         CLOSE_LISTING_SPACE,
         PENDING_SUBMIT_LISTING_SPACE,
         COMPLETE_SUBMIT_LISTING_SPACE,
         FAILED_SUBMIT_LISTING_SPACE
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyspaceediting: false
}


const mlListingSpaceReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_SPACE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyspaceediting: true
        }

        case CLOSE_LISTING_SPACE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyspaceediting: false
        }

        case PENDING_SUBMIT_LISTING_SPACE: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_SPACE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_SPACE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingSpaceReducer